"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireDefault(require("./icon"));

var _time_ago = _interopRequireWildcard(require("./time_ago"));

require("../css/notification_center_item.css");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NotificationCenterItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NotificationCenterItem, _React$Component);

  function NotificationCenterItem(props) {
    var _this;

    _classCallCheck(this, NotificationCenterItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NotificationCenterItem).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "markAsRead", function (event) {
      var _this$props = _this.props,
          id = _this$props.id,
          onRead = _this$props.onRead,
          read = _this$props.read;
      event.preventDefault();

      if (read !== true) {
        onRead(id, event);
      }

      event.stopPropagation();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "remove", function (event) {
      var _this$props2 = _this.props,
          id = _this$props2.id,
          onRemove = _this$props2.onRemove;
      event.preventDefault();
      clearTimeout(_this.timer);
      onRemove(id, event);
      event.stopPropagation();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleBlur", function (event) {
      if (_this.node && _this.node.contains(event.relatedTarget)) return;

      _this.setState({
        focused: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleFocus", function () {
      _this.setState({
        focused: true
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeyDown", function (event) {
      switch (event.key) {
        case ' ':
        case 'Enter':
          event.preventDefault();
          break;

        default:
          break;
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeyUp", function (event) {
      switch (event.key) {
        case ' ':
        case 'Enter':
          _this.markAsRead(event);

          break;

        case 'Delete':
          if (_this.props.removable) {
            _this.remove(event);
          }

          break;

        default:
          break;
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMouseEnter", function (event) {
      event.persist();
      _this.timer = setTimeout(function () {
        return _this.markAsRead(event);
      }, 3000);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMouseLeave", function () {
      clearTimeout(_this.timer);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleRemoveButtonClick", function (event) {
      _this.remove(event);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleRemoveButtonKeyUp", function (event) {
      switch (event.key) {
        case ' ':
        case 'Enter':
          _this.remove(event);

          break;

        default:
          break;
      }
    });

    _this.node = null;
    _this.state = {
      focused: false
    };
    return _this;
  }

  _createClass(NotificationCenterItem, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          content = _this$props3.content,
          extra = _this$props3.extra,
          i18n = _this$props3.i18n,
          icon = _this$props3.icon,
          read = _this$props3.read,
          removable = _this$props3.removable,
          time = _this$props3.time,
          title = _this$props3.title;
      var focused = this.state.focused;
      var classes = (0, _classnames.default)({
        'vn-notification-center-item': true,
        'vn-notification-center-item--read': read === true,
        'vn-notification-center-item--focused': focused === true
      });
      return _react.default.createElement("div", {
        className: classes,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        ref: function ref(node) {
          _this2.node = node;
        },
        role: "button",
        tabIndex: 0
      }, _react.default.createElement("div", {
        className: "vn-notification-center-item__icon"
      }, icon && _react.default.createElement(_icon.default, {
        name: icon
      })), _react.default.createElement("div", {
        className: "vn-notification-center-item__content-wrapper"
      }, title && _react.default.createElement("div", {
        className: "vn-notification-center-item__title"
      }, title), _react.default.createElement("div", {
        className: "vn-notification-center-item__content"
      }, content), extra && _react.default.createElement("div", {
        className: "vn-notification-center-item__extra"
      }, extra), time && _react.default.createElement("div", {
        className: "vn-notification-center-item__time-ago"
      }, time instanceof Date && _react.default.createElement(_time_ago.default, {
        time: time,
        i18n: i18n
      }), !(time instanceof Date) && time)), removable && _react.default.createElement("button", {
        className: "vn-notification-center-item__remove-button",
        onClick: this.handleRemoveButtonClick,
        onKeyUp: this.handleRemoveButtonKeyUp,
        type: "button"
      }, _react.default.createElement(_icon.default, {
        className: "vn-notification-center-item__remove-button-icon",
        name: "close",
        size: 16
      })));
    }
  }]);

  return NotificationCenterItem;
}(_react.default.Component);

NotificationCenterItem.propTypes = {
  content: _propTypes.default.string.isRequired,
  extra: _propTypes.default.element,
  i18n: _time_ago.i18nPropTypes,
  icon: _propTypes.default.string,
  id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
  onRead: _propTypes.default.func.isRequired,
  onRemove: _propTypes.default.func.isRequired,
  read: _propTypes.default.bool,
  removable: _propTypes.default.bool,
  time: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(Date)]),
  title: _propTypes.default.string
};
NotificationCenterItem.defaultProps = {
  extra: undefined,
  i18n: _time_ago.i18nDefaultProps,
  icon: undefined,
  read: false,
  removable: true,
  time: undefined,
  title: undefined
};
NotificationCenterItem.displayName = 'NotificationCenterItem';
var _default = NotificationCenterItem;
exports.default = _default;